import { createContext, useContext, useEffect, useState } from "react";
import { getMedia } from "../lib/api";

const MediaContext = createContext(null);

export function MediaProvider({ children }) {
  const [map, setMap] = useState({});
  useEffect(() => { getMedia().then(setMap).catch(() => {}); }, []);
  const get = (key, fallback = "") => (map[key] ? map[key] : fallback);
  const set = (key, url) => setMap((m) => ({ ...m, [key]: url }));
  return <MediaContext.Provider value={{ get, set }}>{children}</MediaContext.Provider>;
}

export const useMedia = () => useContext(MediaContext);
